export default {"src":"/kelp/_next/static/media/Kred.831240c4.svg","height":492,"width":492,"blurWidth":0,"blurHeight":0};